var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overdue-interest"},[_c('SiruiSearch',{ref:"overdueInterestFormRef",attrs:{"query":_vm.overdueForm,"columns":_vm.formColumn,"isQueryPanel":false,"rules":_vm.formRule,"labelWidth":"160px"},on:{"changeMethod":_vm.changeMethod}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }